module.exports = __webpack_public_path__ + "img/line.2c6d3a68.svg";